import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            KAMPILYA FARMS 
            
          </Link>
            {<img src='/static/images/logokf.JPG' alt='Kampilya Farms' height='40px'></img> }
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/services'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Blog
              </Link>
            </li>
            {/* <li className='nav-item'>
              <Link
                to='/saptarishi'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Saptarishi
              </Link>
            </li> */}
            <li className='nav-item'>
              <Link
                to='/summerplantlist'
                className='nav-links'
                onClick={closeMobileMenu}
              >
               Summer Plants
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/monsoonplantlist'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Monsoon Plants
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/contactdetails'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
            </li>

            {/* <li>
              <Link
                to='/contactdetails'
                className='nav-links-mobile'
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
            </li> */}
          </ul>
          {/* {button && <Button buttonStyle='btn--outline'>Contact</Button>} */}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
